import { jsx } from "react/jsx-runtime";
import { TextButton, TextButtonPriority } from "@wix/wix-ui-tpa/cssVars";
import { useTranslation } from "../../contexts/translation-context.js";
import { classes } from "./ricos-viewer.st.css";
import { DATA_HOOKS } from "../../constants/data-hooks.js";
const ToggleTruncateButtonWUT = ({
  isTruncated,
  onClick
}) => {
  const { t } = useTranslation();
  const buttonText = isTruncated ? t("field.rich-text.read-more-button.label") : t("field.rich-text.read-less-button.label");
  const dataHook = isTruncated ? DATA_HOOKS.TOGGLE_TRUNCATE_BUTTON_READ_MORE : DATA_HOOKS.TOGGLE_TRUNCATE_BUTTON_READ_LESS;
  return /* @__PURE__ */ jsx(
    TextButton,
    {
      priority: TextButtonPriority.primary,
      onClick,
      className: classes.truncateToggle,
      "data-hook": dataHook,
      children: buttonText
    }
  );
};
export {
  ToggleTruncateButtonWUT
};
//# sourceMappingURL=toggle-truncate-button-wut.js.map
